import PropTypes from "prop-types";
import React, { Component } from "react";
import "../radio.css";
import { fontBold, borderTheme, backgroundTheme } from "./AppStyle";

export class Radio extends Component {
  state = {};

  render() {
    const { selected, onChange, text, value, border } = this.props;
    return (
      <div
        style={((value == selected) && (border == "true")) ? borderTheme : null}
        className={(border == "true") ? "modern-radio-container radio-container-border" : "modern-radio-container"}
        onClick={() => {
          onChange(value);
        }}
      >
        <div
          style={(value == selected) ? borderTheme : null} className={`radio-outer-circle ${value !== selected && "unselected"}`}
        >
          <div
            style={backgroundTheme} className={`radio-inner-circle ${value !== selected &&
              "unselected-circle"}`}
          />
        </div>
        <div className="helper-text" style={fontBold}>{text}</div>
      </div>
    );
  }
}

Radio.propTypes = {
  text: PropTypes.node.isRequired,
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired
};
